<template>
  <div id="entry" class="agreement">
    <div class="card-alt mt-0">
      <div class="card-alt-body">
        <div class="row ">
          <div class="col-md-12">
              <div class="">
                <div class="row mb-0">
                  <div class="col-lg-6">
                    <div class="page-header">
                      <div class="row justify-content-end">
                        <div class="col">
                          <h2 class="page-title">{{$t('entry.candidateAgreement')}}</h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-4 text-center" v-if="instructions.pdfURL">
                    <a class="btn btn-xs btn-default btn-circle" :href="instructions.pdfURL" download target="_blank">
                      <i class="mdi mdi-file"></i>
                    </a>
                    <p class="btn-text"><small><strong>{{$t('instructions.btnPDF')}}</strong></small></p>
                  </div>
                  <div class="col-lg-2 col-sm-4 text-center" v-if="instructions.audioURL">
                    <button type="button" class="btn btn-xs btn-default btn-circle" @click="playInstructionAudio">
                      <i class="mdi mdi-headphones-settings"></i>
                    </button>
                    <p class="btn-text"><small><strong>{{$t('instructions.btnAudio')}}</strong></small></p>
                  </div>
                  <div class="col-lg-2 col-sm-4 text-center" v-if="instructions.videoURL">
                    <button type="button" class="btn btn-xs btn-default btn-circle" @click="playInstructionVideo">
                      <i class="mdi mdi-video"></i>
                    </button>
                    <p class="btn-text"><small><strong>{{$t('instructions.btnVideo')}}</strong></small></p>
                  </div>
                </div>
              </div>
              <div>
                <!-- Modal for audio -->
                <b-modal size="md" ref="instrAudioModalRef" hide-footer @hidden="hideAudioModal" :title="$t('instructions.lblAudioInstruction')">
                  <div class="d-block text-left">
                    <audio ref="audioRef" src="" id="audio-container" type="audio/mpeg" width="100%" controls></audio>
                  </div>
                </b-modal>
                <!-- Modal for audio -->
                <b-modal size="lg" ref="instrVideoModalRef" hide-footer @hidden="hideInstructionVideoModal" :title="$t('instructions.lblVideoInstruction')">
                  <div class="d-block text-left">
                    <div id="app">
                      <iframe ref="instrVideoRef" src="" id="video-container" width="100%" height="450"></iframe>
                    </div>
                  </div>
                </b-modal>
              </div>
          </div>
        </div>
        <p class="para height alert alert-info">
          {{instructions.startUpPara}}
        </p>
        <!-- <p class="para height alert alert-info">
          {{$t('candidateProfile.agreement.lblCandidateAgreement1')}} {{universityConfig.abbr}} {{$t('candidateProfile.agreement.lblCandidateAgreement2')}} {{universityConfig.abbr}} {{$t('candidateProfile.agreement.lblCandidateAgreement3')}} {{universityConfig.abbr}} {{$t('candidateProfile.agreement.lblCandidateAgreement4')}}
      </p> -->
        <p class="p-bot">
          {{$t('candidateProfile.agreement.lblUndertakes')}}
        </p>
        <ul>
          <li v-for="(agreementIntrustion,index) in undertakingsList" :key="agreementIntrustion.instructionId">
            <div class="row">
              <div class="col-auto wrap-cb" v-if="agreementIntrustion.checkRequired">
                <label class="c-wrap">
                  <input type="checkbox" checked="checked" v-model="agreementIntrustion.agree" :true-value=true :false-value=false :id="agreementIntrustion.instructionId" @change="selectionChanged(agreementIntrustion)">
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="col-md-9 para">
                {{index + 1}}. {{agreementIntrustion.description}}
              </div>
            </div>
          </li>
        </ul>
        <div class="wrap-cb">
          <label class="c-wrap">
            <input type="checkbox" checked="checked" v-model="agreeCondition" :value=true>
            <span class="checkmark"></span>
            <b class="para">
              <sup>
                <i class="mdi mdi-star text-danger"> </i>
              </sup>{{$t('candidateProfile.agreement.lblRulesAgree')}}</b>
          </label>
        </div>
        <div class="text-right ">
          <button type="button" class="btn  btn btn-orange" value="I Agree" @click="saveData" :disabled="!agreeCondition"> {{$t('candidateProfile.agreement.btnIAgree')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
axios.default.baseURL = ''
import lodash from 'lodash'
export default {
  name: 'Entry',
  data () {
    return {
      agreeCondition: false,
      universityConfig: {},
      undertakingsList: [{agree: true}],
      noOfCheckedInstructions: 0,
      instructions: {},
      agreement: []
    }
  },
  methods: {
    // This method play audio.
    playInstructionAudio () {
      this.$refs.instrAudioModalRef.show()
      this.$refs.audioRef.src = this.instructions.audioURL
      this.$refs.audioRef.play()
    },
    // This method hide details audio.
    hideAudioModal () {
      this.$refs.instrAudioModalRef.hide()
      this.$refs.audioRef.pause()
    },
    // This method play audio.
    playInstructionVideo () {
      this.$refs.instrVideoModalRef.show()
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=1'
    },
    // This method hide details audio.
    hideInstructionVideoModal () {
      this.$refs.instrVideoRef.src = this.instructions.videoURL + '?autoplay=0'
      this.$refs.instrVideoModalRef.hide()
    },
    getProjectConfig () {
      axios.get('o/projectConfig/getUniversityConfig').then(response => {
        this.universityConfig = response.data
        this.getListOfUndertakings()
      }).catch(function (e) {
        console.error(e)
      })
    },
    selectionChanged: function (selectedInstruction) {
      var checked = selectedInstruction.agree
      if (checked === true) {
        this.noOfCheckedInstructions ++
        var selectedData = JSON.parse(JSON.stringify(selectedInstruction))
        delete selectedData.agree
        this.agreement.push(selectedData)
      } else {
        this.noOfCheckedInstructions --
        for (let index = 0; index < this.agreement.length; index++) {
          if (this.agreement[index].instructionId === selectedInstruction.instructionId) {
            this.agreement.splice(index, 1)
          }
        }
      }
    },
    getListOfUndertakings: function () {
      var self = this
      axios.get('r/candidateProfile/getAgreementUndertakings').then(response => {
        if (response.data !== null) {
          this.undertakingsList = response.data
          this.getUserAgreedInstructions()
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    },
    getInstruction: function () {
      // This method get video biodata instructions.
      axios
        .get('r/getGeneralInstructions/' + 'CandidateAgreement')
        .then(response => {
          if (response.status === 200) {
            this.instructions = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getUserAgreedInstructions: function () {
      var self = this
      axios.get('r/candidateProfile/getuseragreedinstructions/' + this.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null) {
          this.agreement = response.data
          if (this.agreement.length > 0) {
            this.noOfCheckedInstructions = this.agreement.length
          }
          for (let index = 0; index < this.agreement.length; index++) {
            for (let innerIndex = 0; innerIndex < this.undertakingsList.length; innerIndex++) {
              if (this.agreement[index].instructionId === this.undertakingsList[innerIndex].instructionId) {
                this.undertakingsList[innerIndex].agree = true
              }
            }
          }
          this.undertakingsList = this.orderedUsers()
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
        console.error(e)
      })
    },
    saveData: function () {
      var self = this
      if (this.noOfCheckedInstructions > 0) {
        axios.post('/r/candidateProfile/saveAgreementUndertakings/' + this.$store.state.candidateProfile.profileUser, this.agreement).then(response => {
          if (response.data !== null && response.data === 'true') {
            this.$toasted.success(self.$t('toastr.toastrIntrustionsSaved'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
            this.$router.push('itCertification')
          } else {
            this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
              theme: 'bubble',
              duration: this.TOASTR_TIME
            })
          }
        }).catch(e => {
          this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
            theme: 'bubble',
            duration: this.TOASTR_TIME
          })
          console.error(e)
        })
      } else {
        this.$toasted.error(self.$t('entry.toastrSelectAtLeastOne'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
      }
    },
    orderedUsers: function () {
      return lodash.orderBy(this.undertakingsList, 'sequence')
    }
  },
  mounted: function () {
    if (this.$store.state.user.userDetails.confirmStatus) {
      this.$router.push({ name: 'entry' })
    } else {
      this.getProjectConfig()
      this.getInstruction()
    }
  }
}
</script>

<style lang="scss">
.agreement {

    ul {
  list-style-type: none;
  padding-left:0px;
  margin-top:20px;
  margin-bottom:40px;
}
.p-bot{
  margin-top:30px; font-weight: 500;
}
     .card-alt {
    // margin:0px;
    padding: 40px;
    min-height: 600px;
    // margin-bottom:80px;
    // box-shadow: none;
  }
  .card-alt-body {
    padding-top: 0px;
  }
  .card-alt-header {
    padding-left: 15px;
    padding-top: 40px;
    padding-bottom: 10px;
  }
    /* The c-wrap */
  .wrap-cb{
    
    margin-bottom:15px;
    position: relative;
    top:-10px;
    label{
    //     display: inline-block;
    // margin-bottom: 15px;
    // padding-left: 10px;
    font-size: 16px;
    text-transform: none;
    font-family: "Roboto", sans-serif;
    color: #37474f;
    
    }
    .wrap{
      
      input{margin-right:25px;}
    }
.c-wrap {
    display: inline-block;
    position: relative;
    // padding-left: 35px;
    padding-right: 15px;
    // margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    b{padding-left:45px;}
}

/* Hide the browser's default checkbox */
.c-wrap input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
}

/* On mouse-over, add a grey background color */
.c-wrap:hover input ~ .checkmark {
    background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.c-wrap input:checked ~ .checkmark {
    background-color: rgb(72, 133, 237);
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.c-wrap input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.c-wrap .checkmark:after {
    left: 10px;
    top: 7px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}}

}
.para{
  font-size: 14px;
}
.height{
  line-height: 1.9;
}
// instruction starts here
    .download-card {
        box-shadow: 12px 15px 20px 0 rgba(46, 61, 73, .15);
        background: #fff;
        padding: 35px;
        border-radius: 6px;
        margin-bottom: 30px;
    }
    .download-card .mdi{
  font-size: 14px;
}
    .instruction-title{
      color: #333;
      font-size: 20px;
      color: #2e3d49;
    }
    .btn-circle {
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 6px 0;
        font-size: 12px;
        line-height: 1.428571429;
        border-radius: 15px;
        background: #02b3e4;
        color: #fff;
        box-shadow: 5px 5px 25px 0 rgba(46, 61, 73, .2);
        margin-bottom: 10px;
        transition: all .2s ease-in;
    }
 .btn-circle.btn-xs {
        width: 30px;
        height: 30px;
        padding: 4px 7px;
        font-size: 18px;
        line-height: 1.33;
        border-radius: 20px;
    }
    .btn-circle.btn-lg {
        width: 50px;
        height: 50px;
        padding: 10px 16px;
        font-size: 18px;
        line-height: 1.33;
        border-radius: 25px;
    }

    .btn-circle.btn-xl {
        width: 70px;
        height: 70px;
        padding: 10px 16px;
        font-size: 24px;
        line-height: 1.33;
        border-radius: 35px;
    }
    .btn-circle:hover{
      background:#71d102;
        color: #fff;
       
    }
    .download-card .zmdi {
        font-size: 20px;
        
    }
  
    .instructions li{
  
    	list-style-type: none;

    font-size: 15px;
    text-indent: -1.28571429em;
    }
    .instructions li:before {
    font-family: Material Design Icons;
    content: "\f2c7";
  color: #000;
    position: relative;
    padding-right: 10px;
    top: -1px;
        list-style-position: inside;
}
.download-card .btn-text{
  font-size: 12px;
  font-weight: 700;
}
.video-card{
    box-shadow: 12px 15px 20px 0 rgba(46, 61, 73, .15);
        background: #fff;
        padding: 10px 25px;
        border-radius: 6px;
        margin-bottom: 30px;
}
.video-card p{
  margin-top: 10px;
  margin-bottom: 10px;
}
.video-card .dropzone{
  min-height:30px;
  padding:0;
}
.video-card .dropzone .dz-message {

    margin: 3px;
}
.modal-height {
    height: 100%;
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/registration/agreement.vue